export enum TenantPermissions {
  //Permission to access Fordes
  CanAccessFordesk = "can_access_fordesk",
  //permission to access tenant on the CP side
  CanAccessClientPortal = "can_access_client_portal",

  CanPerformSynchronization = "can_perform_synchronization",
  CanPerformFinanceExtension = "can_perform_finance_extension",
  CanPerformClientPortalConfig = "can_perform_client_portal_config",
  CanPerformMasterdata = "can_perform_masterdata",
  CanPerformNotifications = "can_perform_notifications",
  CanPerformProspects = "can_perform_prospects",
  CanPerformSales = "can_perform_sales",
  CanPerformTemplatesMgtAdmin = "can_perform_templates_mgt_admin",
  CanPerformAdmin = "can_perform_fordesk_admin",

  CanPerformOutgoingInvoice = "can_perform_outgoing_invoices",
  CanPerformIncomingInvoice = "can_perform_incoming_invoices",
  CanPerformOpenIncomingInvoices = "can_perform_open_incoming_invoices",
  CanPerformFinanceGeneralData = "can_perform_finance_general_data",

  CanPerformQuote = "can_perform_quote",
  CanPerformReporting = "can_perform_reporting",
  CanPerformUserManagement = "can_perform_user_management",
  CanPerformOcr = "can_perform_ocr",
  CanSeeQuotesWidget = "can_see_quotes_widget",
  CanSeeNotificationsWidget = "can_see_notifications_widget",
}
